<template>
  <va-card style="height:800px!important">
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <h2 class="text-center pb-5" style="font-size:32px!important;">CHANGE PASSWORD</h2>
    <div class="row">
      <div class="flex md6 offset-md-3">
        <va-card>
          <form @submit="onsubmit">
            <div class="pb-3">
              <label>Current Password</label>
              <input
                v-model="oldPassword"
                type="password"
                required
                class="pt-2 pb-2"
                style="color:black!important;width:100%!important;"
              />
              <!-- <span toggle="#password-field" class="fa fa-fw fa-eye field-icon toggle-password"></span> -->
            </div>

            <div class="pb-3">
              <label>New Password</label>
              <input
                v-model="newPassword"
                type="password"
                required
                class="pt-2 pb-2"
                style="color:black!important;width:100%!important;"
              />
            </div>
            <div class="pb-3">
              <label>Confirm Password</label>
              <input
                v-model="confirmPassword"
                type="password"
                required
                class="pt-2 pb-2"
                style="color:black!important;width:100%!important;"
              />
            </div>
          <p class="py-1" style="color:red;font-size:12px">{{msg_password}}</p>
            <div class="d-flex justify--center mt-3">
              <button
                type="submit"
                class="pt-2 pb-2 btn btn-success"
                style="width:100%!important;"
              >Submit</button>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </va-card>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'login',
  components: {
    VueElementLoading,
  },
  data () {
    return {
      visible: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      message: '',
      msg: '',
      msg_password: null,
    }
  },
  watch: {
    confirmPassword: function () {
      if (this.newPassword != this.confirmPassword) { this.msg_password = 'Passwords not matching' } else this.msg_password = null
    },
    newPassword: function () {
      if (this.confirmPassword != this.newPassword) { this.msg_password = 'Passwords not matching' } else this.msg_password = null
    },
  },
  methods: {
    onsubmit (evt) {
      this.visible = true

      var data = {}

      data['oldPassword'] = this.oldPassword
      data['newPassword'] = this.newPassword
      data['confirmPassword'] = this.confirmPassword

      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/admin/password/change',
        data: data,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then(response => {
          this.visible = false
          this.status = response.data.status
          this.msg = response.data.msg
          if (response.data.status === true) {
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push({ name: 'dashboard' })
              },
              { messageType: 'success' }
            )
          } else {
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push({ name: 'dashboard' })
              },
              { messageType: 'error' }
            )
          }
        })
        .catch(err => {
          if (err.response.data.status === false) {
            this.msg = 'Please Try Again'
          }
        })
    },
  },
}
</script>
